import React from "react";

import Wrapper from "../layout/Wrapper";
import Sidebar from "../layout/Sidebar";
import Main from "../layout/Main";
import Navbar from "../layout/Navbar";
import Content from "../layout/Content";
import Footer from "../layout/Footer";

const Dashboard = ({ children }) => (
  <React.Fragment>
    <Wrapper>
      <Sidebar />
      <Main>
        <Navbar />
        <Content>{children}</Content>
        <Footer />
      </Main>
    </Wrapper>
  </React.Fragment>
);

export default Dashboard;
